export default __webpack_public_path__ + "static/media/search_result_icon.e608acb8.svg";